export default __webpack_public_path__ + "static/media/login-bg.b5036acf.jpg";